import { render, staticRenderFns } from "./fakeBotDetail.vue?vue&type=template&id=6b814932"
import script from "./fakeBotDetail.vue?vue&type=script&lang=js"
export * from "./fakeBotDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports